module.exports = __webpack_public_path__ + "img/telegram.9ae8e55a.png";